import { SettingsTabs } from './Settings.enum';
import { tSettingsContext, tSettingsInfo } from './Settings.types';

export const DEFAULT_SETTINGS_INFO: tSettingsInfo = {
  seats: {
    available: 0,
    used: 0,
  },
};

export const SETTINGS_INITIAL_STATE: tSettingsContext = {
  selectedTab: SettingsTabs.PROFILE,
  setSelectedTab: () => {},
  showProfileSection: true,
  showStorageSection: true,
  showWorkspaceSection: true,
  showTeamSection: true,
  currentSettingsInfo: DEFAULT_SETTINGS_INFO,
  showSubscriptionManagerSection: true,
  setCurrentSettingsInfo: () => {},
  refreshSettingsInfoSilently: async () => false,
  showInvoicingSection: true,
  showPurchaseApiKeyModal: false,
  togglePurchaseApiKeyModal: () => {},
  apiKeyAddon: null,
  purchaseApiKey: () => {},
  purchasingApiKey: false,
  keysData: [],
  regeneratingApiKey: false,
  regenerateApiKey: () => Promise.resolve(),
};
